import { DITypes } from "@/core/@types/types";
import type { HttpClient, IHttpMiddlewareIntercept } from "./protocols/types";
import { inject, injectable, optional } from "inversify";
import { FinancasDevHttpDi, type IFinancasDevHttp } from "./FinancasDevHttp";

@injectable()
export default class HttpMiddlewareIntercept
  implements IHttpMiddlewareIntercept
{
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  @optional()
  httpClient!: HttpClient;

  @inject(FinancasDevHttpDi)
  private financasDevHttp!: IFinancasDevHttp;

  async sendFinancasToken(): Promise<void> {
    try {
      if (import.meta.env.DEV) {
        await this.financasDevHttp.post("post", "/api/refreshCookie");
      } else {
        await this.httpClient.post({
          url: "/refreshCookie"
        });
      }
    } catch (error: any) {
      if (error.response?.status === 302) {
        return;
      }
      if (error.response?.status === 404) {
        return;
      }
      throw error;
    }
  }
}
